const translations = {
  "en": {
    "Choose how advanced Edgen gets, from essential signals to a fully tailored investment assistant built for you.": "Choose how advanced Ed gets, from essential signals to a fully tailored investment assistant built for you.",
    "Christmas Offer": "Christmas Offer",
    "Edgen for teams or business?": "Ed for teams or business?",
    "Your Personalized AI for Markets": "Your Personalized AI for Markets"
  },
  "zh-tw": {
    "Choose how advanced Edgen gets, from essential signals to a fully tailored investment assistant built for you.": "選擇 Ed 的進階程度，從基本訊號到為你量身打造的完整投資助手。",
    "Christmas Offer": "聖誕節優惠",
    "Edgen for teams or business?": "Ed 適合團隊或企業使用？",
    "Your Personalized AI for Markets": "你專屬的市場人工智慧"
  }
};

export default translations;
